<script>
	import { createEventDispatcher } from "svelte";
	import iconPlay from "../../images/play.svg";
	import iconPause from "../../images/pause.svg";

	let dispatch = createEventDispatcher();

	const icons = {
		play: iconPlay,
		pause: iconPause,
	};

	export let isPlaying;
</script>

<button id="play" on:click={() => dispatch("playPause")} class:play={!isPlaying} class:pause={isPlaying}>
	<img src={isPlaying ? icons.pause : icons.play} alt="play" />
</button>

<style lang="scss">
	button {
		width: 32px;
		height: 32px;
		border: none;
		cursor: pointer;
		background-color: #d9d9d9;
		box-shadow: 0px 0px 6px rgba(255, 255, 255, 0.5);
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;

		@media (min-width: $breakpoint-textwidth) {
			width: 48px;
			height: 48px;
		}

		&.play {
			img {
				margin-left: 3px;
				width: 16px;
			}
		}

		&.pause {
			img {
				width: 14px;
			}
		}
	}
</style>
